import { render, staticRenderFns } from "./FreetextAcceptNotificationModal.vue?vue&type=template&id=607514fa"
import script from "./FreetextAcceptNotificationModal.vue?vue&type=script&lang=js"
export * from "./FreetextAcceptNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports